import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  NavBarAppLeftComponent,
  NavBarAppRightComponent,
  NavBarAppTitleComponent,
  NavbarComponent,
  NavBarLogoComponent,
  NavBarSubTitleComponent,
  SubNavbarComponent,
  SubNavbarLeftComponent,
  SubNavbarRightComponent } from './navbar.component';

@NgModule({
  imports: [RouterModule, CommonModule],
  declarations: [
    NavBarAppLeftComponent,
    NavBarAppRightComponent,
    NavBarAppTitleComponent,
    NavBarSubTitleComponent,
    NavBarLogoComponent,
    NavbarComponent,
    SubNavbarComponent,
    SubNavbarLeftComponent,
    SubNavbarRightComponent
  ],
  exports: [
    NavBarAppLeftComponent,
    NavBarAppRightComponent,
    NavBarAppTitleComponent,
    NavBarSubTitleComponent,
    NavBarLogoComponent,
    NavbarComponent,
    SubNavbarComponent,
    SubNavbarLeftComponent,
    SubNavbarRightComponent
  ]
})
export class NavbarModule {}
